import React from "react";

const ErrorPage = () => {
  return <div>Stranica nije pronađena</div>;
};

export default ErrorPage;
